import Router from 'next/router'

// NY lookup lives at /traffic/lookup; the WIN-1625 Docket redesign runs the same
// steps under /traffic/lookup/v2 so it can be A/B tested via PostHog.
export const LOOKUP_BASE = '/traffic/lookup'
export const DOCKET_BASE = '/traffic/lookup/v2'

// window.location keeps the i18n prefix (/en/traffic/lookup, /es/...) that
// Next's router strips, so compare paths without it.
export const stripLocale = (path = '') => path.replace(/^\/(en|es)(?=\/|$)/, '') || '/'

export const isDocketPath = (rawPath = '') => {
  const path = stripLocale(rawPath)
  return path === DOCKET_BASE || path.startsWith(`${DOCKET_BASE}/`) || path.startsWith(`${DOCKET_BASE}?`)
}

const currentPath = () => {
  if (typeof window !== 'undefined') return window.location.pathname
  return Router.pathname || ''
}

// Path of a NY lookup step (`results`, `checkout`, ...) in whichever design the
// visitor is on, so the store keeps Docket visitors on /traffic/lookup/v2.
export const lookupPath = (step = '', path = currentPath()) => {
  const base = isDocketPath(path) ? DOCKET_BASE : LOOKUP_BASE
  return step ? `${base}/${step}` : base
}
